import UserLayout from 'Authentic/Layout/UserLayout/UserLayout';
import React from 'react';

const WebSiteSettings = () => {
  return (
    <>
    
    <UserLayout>

    <h1>Hello Bangladesh</h1>


    </UserLayout>
    
    </>
  );
};



export default WebSiteSettings;
